import { Flex } from 'antd';
import { FilledDanger, WarningCircle } from '../../icons';
import styled from 'styled-components';

interface InfoMessageProps {
  text: string;
  type: 'help' | 'warning';
}

const messageColors: Record<InfoMessageProps['type'], string> = {
  help: 'var(--clr-inline-help)',
  warning: 'var(--clr-inline-warning)',
};

const InfoMessageWrapper = styled(Flex)<{ $type: InfoMessageProps['type'] }>`
  margin-top: 5px;
  p {
    font-style: italic;
    font-size: 11px;
    line-height: 14px;
    color: ${({ $type }) => messageColors[$type]};
  }
  .icon {
    flex-shrink: 0;
    font-size: 12px;
  }
  .help-icon {
    color: var(--clr-inline-help);
  }
  .warning-icon {
    color: var(--clr-inline-warning);
  }
`;

const InfoMessage = ({ text, type }: InfoMessageProps) => {
  return (
    <InfoMessageWrapper data-testid="info-message" $type={type}>
      {type === 'help' && <WarningCircle className="help-icon d-flex ai-start" />}
      {type === 'warning' && <FilledDanger className="warning-icon d-flex ai-start" />}
      <p>{text}</p>
    </InfoMessageWrapper>
  );
};

export default InfoMessage;
